import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation10({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)
  const [isShaking, setIsShaking] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setShowBadge(true)
      setIsShaking(true)
    }, 200)

    setTimeout(() => setIsShaking(false), 2500)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0) rotate(0deg); }
          10% { transform: translateX(-10px) rotate(-2deg); }
          20% { transform: translateX(10px) rotate(2deg); }
          30% { transform: translateX(-10px) rotate(-2deg); }
          40% { transform: translateX(10px) rotate(2deg); }
          50% { transform: translateX(-8px) rotate(-1deg); }
          60% { transform: translateX(8px) rotate(1deg); }
          70% { transform: translateX(-6px) rotate(-1deg); }
          80% { transform: translateX(6px) rotate(1deg); }
          90% { transform: translateX(-4px) rotate(0deg); }
        }
        @keyframes scaleUp {
          0% { transform: scale(0.5); opacity: 0; }
          50% { transform: scale(1.2); }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes vibrate {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-2px); }
          75% { transform: translateX(2px); }
        }
        .shake {
          animation: shake 0.8s ease-in-out;
        }
        .shake-infinite {
          animation: shake 0.5s ease-in-out infinite;
        }
        .vibrate {
          animation: vibrate 0.1s linear infinite;
        }
        .scale-up {
          animation: scaleUp 0.5s ease-out forwards;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        <div className={`${isShaking ? 'shake-infinite' : ''}`}>
          <div className={`${showBadge ? 'scale-up' : 'opacity-0'}`}>
            {/* Badge */}
            <div className="bg-tessan-yellow p-1 rounded-2xl shadow-2xl shadow-tessan-yellow/50">
              <div className={`w-32 h-32 sm:w-40 sm:h-40 bg-tessan-cream rounded-xl flex items-center justify-center ${isShaking ? 'vibrate' : ''}`}>
                <span className="text-5xl sm:text-7xl">{badge.emoji}</span>
              </div>
            </div>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-500 delay-500 ${showBadge ? 'opacity-100' : 'opacity-0'}`}>
          <div className={`text-2xl sm:text-4xl font-black text-tessan-yellow ${isShaking ? 'vibrate' : ''}`}>
            {badge.name}
          </div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
